import { BaseService } from "./base.service";
import AddInternalUser from "models/SignUp/InternalUser";
import { IUserAndAdGroup } from "models/UserAndAdGroupModel";
import { IUserByDepartmentModel } from "models/UserByDepartmentModel";
import { IMenuAccessRightModel } from "models/MenuAccessRightModel";
import { IUser } from "models/InternalUser/UserModel";
import { GuestUserModel } from "models/BidCommittee/BidCommitteeDetailModel";

class UserServiceInternal extends BaseService {
	saveUser = async (userModel: AddInternalUser): Promise<number> =>
		this.callApi<number>(`User/Signup`, "POST", undefined, userModel);

	assignRole = async (userId: number, roleId: number): Promise<undefined> =>
		this.callApi<undefined>(`User/AssignRole`, "POST", undefined, {
			userId: userId.toString(),
			roleId: roleId.toString(),
		});

	getUserAndAdGroupList = async (
		moduleId: number,
		modulePhaseId: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetUserAndAdGroupList/${moduleId}/${modulePhaseId}`,
			"GET"
		);

	getInternalUsers = async (): Promise<IUser[]> =>
		this.callApi<IUser[]>(`User/GetInternalUsers`, "GET");

	getUserListByDepartmentId = async (
		departmentId: number
	): Promise<IUserByDepartmentModel[]> =>
		this.callApi<IUserByDepartmentModel[]>(
			`User/GetUserListByDepartmentId/${departmentId}`,
			"GET"
		);

	getUserMenuAccessRights = async (): Promise<IMenuAccessRightModel[]> =>
		this.callApi<IMenuAccessRightModel[]>(
			`User/GetUserMenuAccessRights`,
			"GET"
		);

	getConversionToUserAndAdGroupList = async (
		moduleId: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetConversionToUserAndAdGroupList/${moduleId}`,
			"GET"
		);

	getConversionToUserAndBidCommitteeList = async (
		moduleId: number
	): Promise<IUserAndAdGroup[]> =>
		this.callApi<IUserAndAdGroup[]>(
			`User/GetConversionToUserAndBidCommitteeList/${moduleId}`,
			"GET"
		);

	getUserListByRegionId = async (
		regionId: number
	): Promise<IUserByDepartmentModel[]> =>
		this.callApi<IUserByDepartmentModel[]>(
			`User/GetUsersByRegionId/${regionId}`,
			"GET"
		);
	getGuestUsers = async (): Promise<GuestUserModel[]> =>
		this.callApi<GuestUserModel[]>(
			"User/GetGuestUsers",
			"GET",
			undefined,
			undefined
		);
	getBidCommitteeMemberInternalUserList = async (): Promise<GuestUserModel[]> =>
		this.callApi<GuestUserModel[]>(
			"User/BidCommitteeMemberInternalUserList",
			"GET",
			undefined,
			undefined
		);
}

export const UserService = new UserServiceInternal();
